import {Routes} from "@angular/router";
import {AuthGuard} from "@shared/route-guards";
import {mainRoutes} from "./main";

enum Paths {
    EMPTY = "",
    LOADING = "loading",
    INDEX = "index",
    FORBIDDEN = "403",
    NOT_FOUND = "**",
    POLICY = "policy"
}

const MainPageLoaderComponent = () => import("@shared/ui").then(m => m.MainPageLoaderComponent);
const MainPageComponent = () => import("@pages/main").then(m => m.MainPageComponent);
const PolicyComponent = () => import("@shared/ui").then(m => m.PolicyComponent);
const Error403Component = () => import("@shared/ui").then(m => m.Error403Component);
const Error404Component = () => import("@shared/ui").then(m => m.Error404Component);

export const routes: Routes = [
    {path: Paths.EMPTY, redirectTo: "loading", pathMatch: "full"},
    {path: Paths.LOADING, loadComponent: MainPageLoaderComponent},
    {
        path: Paths.INDEX,
        canActivate: [AuthGuard],
        loadComponent: MainPageComponent,
        children: mainRoutes
    },
    {path: Paths.POLICY, loadComponent: PolicyComponent},
    {path: Paths.FORBIDDEN, loadComponent: Error403Component},
    {path: Paths.NOT_FOUND, loadComponent: Error404Component},
];
